// extracted by mini-css-extract-plugin
export default {"wrap":"MoveMinersModal_wrap__yHdAo","title":"MoveMinersModal_title__XH35p","buttons":"MoveMinersModal_buttons__5u2ln","label":"MoveMinersModal_label__EDFoY"};